import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import Reveal from '../components/common/Reveal';
import { SectionHeader, Card, Tag } from '../components/ui';

export default function BooksPage() {
  const [books, setBooks] = useState([]);
  useEffect(() => { api.get('/books').then(r => setBooks(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <div style={{ padding: '120px 40px 40px', textAlign: 'center', background: 'linear-gradient(160deg,var(--cream),var(--soft-orange))' }}>
        <SectionHeader title="Wijdan" accent="Publications" sub="Our curated collection of books" />
      </div>
      <section style={{ padding: '80px 40px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 24 }}>
          {books.map((b, i) => (
            <Reveal key={b.id} delay={i * .08}>
              <Card>
                <div style={{ height: 200, background: 'linear-gradient(135deg,var(--soft-orange),rgba(232,133,26,.12))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '4.5rem', position: 'relative' }}>
                  {b.cover_emoji}
                  <div style={{ position: 'absolute', top: 12, right: 12 }}><Tag>{b.genre}</Tag></div>
                </div>
                <div style={{ padding: 22 }}>
                  <h3 className="serif" style={{ fontSize: '1.3rem', margin: '0 0 4px' }}>{b.title}</h3>
                  <p style={{ fontSize: 13, color: '#999', marginBottom: 10 }}>Wijdan Publications · {b.year}</p>
                  <p style={{ fontSize: 14, color: 'var(--brown)', fontWeight: 300, lineHeight: 1.6 }}>{b.description}</p>
                </div>
              </Card>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
